import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface DifficultySelectProps {
  value?: string;
  onChange?: (value: string) => void;
}

export const DifficultySelect = ({ value, onChange }: DifficultySelectProps) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[160px]">
        <SelectValue placeholder="Difficulty" />
      </SelectTrigger>
      <SelectContent className="bg-background border z-50">
        <SelectItem value="all">All Difficulties</SelectItem>
        <SelectItem value="1">1 - Easy</SelectItem>
        <SelectItem value="2">2</SelectItem>
        <SelectItem value="3">3 - Medium</SelectItem>
        <SelectItem value="4">4</SelectItem>
        <SelectItem value="5">5 - Hard</SelectItem>
      </SelectContent>
    </Select>
  );
};
